import { ComponentInstance } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import { weakMapMemoize } from '@reduxjs/toolkit';

const emptyPath: never[] = [];
Object.freeze(emptyPath);

/**
 * Returns mapping where keys are component IDs and values are descriptor property paths to the
 * corresponding component instances. The mapping is built by traversing the given component
 * hierarchy starting from the given root component. Paths are also relative to the root component!
 *
 * @param rootComponent root component of the hierarchy
 * @returns mapping from component instance IDs to component instances
 */
const getComponentInstancePathMappingByIds = weakMapMemoize(
  (rootComponent: ComponentInstance | null | undefined): Record<string, ('children' | number)[]> => {
    const mapping: Record<string, ('children' | number)[]> = {};
    if (rootComponent) {
      mapping[rootComponent.id] = emptyPath;
      rootComponent.children.forEach((child, index) => {
        const childMapping = getComponentInstancePathMappingByIds(child);
        Object.entries(childMapping).forEach(([childId, nestedPath]) => {
          mapping[childId] = ['children', index, ...nestedPath];
        });
      });
    }
    return mapping;
  },
);

export default getComponentInstancePathMappingByIds;
